import React from "react"
import RESTProtectionConfigurationRestService from "./RESTProtectionConfigurationRestService"
import { TFunction } from "i18next"

class RESTProtectionConfigurationService {

    static async getAll(setRestProtectionConfigurations: React.Dispatch<any>) {
        try {
            const restProtectionConfigurations = await RESTProtectionConfigurationRestService.getAll()
            setMethodsAsBool(restProtectionConfigurations)

            setRestProtectionConfigurations(restProtectionConfigurations)
        } catch (error) {
            return Promise.reject(error)
        }
    }

    static async getById(id: number): Promise<any> {
        try {
            return await RESTProtectionConfigurationRestService.getById(id)
        } catch (error) {
            return Promise.reject(error)
        }
    }

    static async getByAppId(setRestProtectionConfigurations: React.Dispatch<any>, appId: number) {
        try {
            const restProtectionConfigurations = await RESTProtectionConfigurationRestService.getByAppId(appId)
            setMethodsAsBool(restProtectionConfigurations)

            setRestProtectionConfigurations(restProtectionConfigurations)
        } catch (error) {
            return Promise.reject(error)
        }
    }

    static async createEndpointConfiguration(endpointConfig: any, t: TFunction, setRestProtectionConfigurations: React.Dispatch<any>) {
        try {
            endpointConfig.method = endpointConfig.postEnabled ?
                (endpointConfig.putEnabled ? 'post,put' : 'post') : (endpointConfig.putEnabled ? 'put' : '')
            await RESTProtectionConfigurationRestService.create(endpointConfig)

            const restProtectionConfigurations = await RESTProtectionConfigurationRestService.getByAppId(endpointConfig.appId)
            setMethodsAsBool(restProtectionConfigurations)
            setRestProtectionConfigurations(restProtectionConfigurations)

            return t('restprotection.createEndpointConfigurationSuccess', { name: endpointConfig.name })
        } catch (error) {
            return Promise.reject(error)
        }
    }

    static async editEndpointConfiguration(endpointConfig: any, t: TFunction, setRestProtectionConfigurations: React.Dispatch<any>) {
        try {
            endpointConfig.method = endpointConfig.postEnabled ?
                (endpointConfig.putEnabled ? 'post,put' : 'post') : (endpointConfig.putEnabled ? 'put' : '')
            await RESTProtectionConfigurationRestService.update(endpointConfig)

            const restProtectionConfigurations = await RESTProtectionConfigurationRestService.getByAppId(endpointConfig.appId)
            setMethodsAsBool(restProtectionConfigurations)
            setRestProtectionConfigurations(restProtectionConfigurations)

            return t('restprotection.updateSuccess', { name: endpointConfig.name })
        } catch (error) {
            return Promise.reject(error)
        }
    }

    static async deleteEndpointConfiguration(endpointConfig: any, t: TFunction, setRestProtectionConfigurations: React.Dispatch<any>) {
        try {
            await RESTProtectionConfigurationRestService.delete(endpointConfig.id)

            const restProtectionConfigurations = await RESTProtectionConfigurationRestService.getByAppId(endpointConfig.appId)
            setMethodsAsBool(restProtectionConfigurations)
            setRestProtectionConfigurations(restProtectionConfigurations)

            return t('restprotection.deleteSuccess', { name: endpointConfig.name })
        } catch (error) {
            return Promise.reject(error)
        }
    }

    static async getAllFieldConfigsForEndpointId(id: number): Promise<any> {
        try {
            return await RESTProtectionConfigurationRestService.getFieldConfigsForEndpointId(id)
        } catch (error) {
            return Promise.reject(error)
        }
    }

    static async getAllFieldConfigurations(setRestProtectionFieldConfigurations: React.Dispatch<any>) {
        try {
            const configs = await RESTProtectionConfigurationRestService.getAllFieldConfigurations()
            setRestProtectionFieldConfigurations(configs)
        } catch (error) {
            return Promise.reject(error)
        }
    }

    static async addFieldConfigurationToEndpoint(fieldConfiguration: any, t: TFunction, setRestProtectionConfigurations: React.Dispatch<any>) {
        try {
            const config = await RESTProtectionConfigurationRestService.addFieldConfigToEndpoint(fieldConfiguration)
            const endpoint = await RESTProtectionConfigurationService.getById(fieldConfiguration.endpointProfile)
            const restProtectionConfigurations = await RESTProtectionConfigurationRestService.getByAppId(endpoint.appId)
            setMethodsAsBool(restProtectionConfigurations)
            setRestProtectionConfigurations(restProtectionConfigurations)

            return t('restprotection.createFieldConfigurationSuccess', { path: config.jsonPath })
        } catch (error) {
            return Promise.reject(error)
        }
    }

    static async editFieldConfigurationForEndpoint(fieldConfiguration: any, t: TFunction, setRestProtectionConfigurations: React.Dispatch<any>) {
        try {
            const config = await RESTProtectionConfigurationRestService.updateFieldConfig(fieldConfiguration)
            const endpoint = await RESTProtectionConfigurationService.getById(fieldConfiguration.endpointProfile)
            const restProtectionConfigurations = await RESTProtectionConfigurationRestService.getByAppId(endpoint.appId)
            setMethodsAsBool(restProtectionConfigurations)
            setRestProtectionConfigurations(restProtectionConfigurations)

            return t('restprotection.editFieldConfigurationSuccess', { path: config.jsonPath })
        } catch (error) {
            return Promise.reject(error)
        }
    }

    static async deleteFieldConfigurationFromEndpoint(fieldConfig: any, t: Function, setRestProtectionConfigurations: React.Dispatch<any>) {
        try {
            const endpoint = await RESTProtectionConfigurationService.getById(fieldConfig.endpointProfile)
            await RESTProtectionConfigurationRestService.deleteFieldConfig(fieldConfig.id)
            const restProtectionConfigurations = await RESTProtectionConfigurationRestService.getByAppId(endpoint.appId)
            setMethodsAsBool(restProtectionConfigurations)
            setRestProtectionConfigurations(restProtectionConfigurations)

            return t('restprotection.deleteFieldConfigurationSuccess', { path: fieldConfig.jsonPath })
        } catch (error) {
            return Promise.reject(error)
        }
    }
}




function setMethodsAsBool(configs: any[]) {
    configs.forEach((config: any) => {
        if ((config.method as string).includes('post'))
            config.postEnabled = true
        if ((config.method as string).includes('put'))
            config.putEnabled = true
    })
}


export default RESTProtectionConfigurationService
